import { render } from "./ClinicHealthSystemsOverlay.vue?vue&type=template&id=1a5f5b86&scoped=true&lang=pug"
import script from "./ClinicHealthSystemsOverlay.vue?vue&type=script&lang=js"
export * from "./ClinicHealthSystemsOverlay.vue?vue&type=script&lang=js"

import "./ClinicHealthSystemsOverlay.vue?vue&type=style&index=0&id=1a5f5b86&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5f5b86"]])

export default __exports__